<template>
  <div v-if="isAuthorized">
    <button class="zendesk-chat__button"
      @click="toggleChatWindow"
      aria-haspopup="true"
      aria-expanded="false">
      <i class="fal fa-circle-question"></i>
    </button>
  </div>
</template>

<script>
import authMixin from '@profile/mixins/auth';
import zendesk from '@services/zendesk.service';

export default {
  name: 'zendesk',

  mixins: [
    authMixin,
  ],

  data() {
    return {
      showChatWindow: false,
    };
  },

  mounted() {
    if (this.referredFromUrbanSitter) {
      this.showChatWindow = true;
      zendesk.open();
    }

    if (window.zE) {
      this.hideWidgetOnClose();
    } else {
      const interval = setInterval(() => {
        if (window.zE) {
          this.hideWidgetOnClose();
          clearInterval(interval);
        }
      }, 300);
    }
  },

  computed: {
    isCompleteCareUser() {
      return this.$store.state.user.current?.completeCare;
    },

    referredFromUrbanSitter() {
      return this.isCompleteCareUser && document.referrer.includes('urbansitter.com');
    },
  },

  methods: {
    toggleChatWindow() {
      this.showChatWindow = !this.showChatWindow;
      if (this.showChatWindow) {
        zendesk.open();
      } else {
        zendesk.close();
      }
    },
    hideWidgetOnClose() {
      if (window.zE) {
        window.zE('messenger:on', 'close', () => {
          this.toggleChatWindow();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.zendesk-chat__button {
  width: 28px;
  height: 28px;
  padding: 0;
  font-size: 24px;
  color: var(--gray-500);
  cursor: pointer;
  background: none;
  border: 0;
  margin-right: var(--grid-unit);

  &--close {
    position: absolute;
    top: 60px;
    right: -5px;
    background-color: var(--sapphire-500);
    border-radius: 100%;
    height: 42px;
    width: 42px;
    transition: background-color var(--button-fade);

    &:hover {
      background-color: var(--sapphire-500);
    }
  }
}
</style>
